import { SourcingSetting } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';

import LightningBoltIcon from '@/assets/icons/solid-lightning-bolt.svg';
import { Typography } from '@/components/ui/typography';

interface AutomationStatusPillProps {
  automation?: SourcingSetting | null;
}

export function AutomationStatusPill({
  automation,
}: AutomationStatusPillProps) {
  if (!automation) return null;

  const isAutomationRunning =
    automation.budget_automation_enabled ||
    automation.funnel_automation_enabled ||
    automation.hiring_automation_enabled;

  if (!isAutomationRunning) return null;

  return (
    <div className="bg-fx-brand-50 flex h-6 w-fit items-center justify-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3">
      <img src={LightningBoltIcon} alt="Status" />
      <Typography variant="small1" className="!text-fx-neutral-600">
        <FormattedMessage
          defaultMessage="Automation running"
          description="Indicates that the automation is running"
        />
      </Typography>
    </div>
  );
}
